<app-detail-template class="detail-container">
  <div container-header>
    <member-archive-chase-detail-header></member-archive-chase-detail-header>
  </div>
  <div container-body>
    <router-outlet></router-outlet>
  </div>
</app-detail-template>